var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 6603"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rect\\xE1ngulo 986",
    fill: "none",
    d: "M0 0h25v25H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 6603"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 1252",
    d: "M8.328 3.601a.9.9 0 00-.034 1.264l7.352 7.885-7.352 7.883a.9.9 0 00.034 1.265.871.871 0 001.246-.034l7.926-8.5a.9.9 0 000-1.23l-7.926-8.5a.871.871 0 00-1.246-.033z",
    fill: "#223983"
  })))));
}

export default SvgArrowRightinline;